// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Debit, {getDefaultState as getDebitDefaultState} from '@deere/cps-it.warranty-model-factory/lib/debit';
import KeyValueCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import t from 'tcomb';

const State = t.struct({
    adjustmentTypes: KeyValueCollection,
    busyCounter: BusyCounter,
    debit: Debit,
    isConfirmationModalVisible: t.Boolean,
    isPartialDebitModalVisible: t.Boolean
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        adjustmentTypes: getDefaultKeyValueCollection(),
        busyCounter: getBusyCounterDefaultState(),
        debit: getDebitDefaultState(),
        isConfirmationModalVisible: false,
        isPartialDebitModalVisible: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/state/index.js